import { action } from 'typesafe-actions';
import { ADD_OPTION, MODIFY_OPTION, REMOVE_OPTION, SET_OPTIONS } from './types';

export const addOption = (value?: string) => action(ADD_OPTION, value);
export const removeOption = (index: number) => action(REMOVE_OPTION, index);
export const modifyOption = (params: { index: number; value: string }) => action(MODIFY_OPTION, params);

export const setOptions = (values: Array<string>) => action(SET_OPTIONS, values);
